<template lang="pug">
  v-container
    v-row
      v-col(cols='12')
        v-toolbar(color='primary' dark='')
          | Sales Comparison
        div(style='position: relative')
          v-overlay(absolute='' :value='loadingServerSideData')
            .text-h1.w-100 Loading...
          store-comp-chart(:data='graphData')
      v-col(lg='6' cols='12')
        v-item-group(v-model='dateIntvSelected' mandatory='')
          v-item(v-for='(item, index) in dateIntvItems' :key='index')
            template(v-slot='{ active, toggle }')
              v-chip.text-capitalize.mr-2(color='primary' @click='toggle' :outlined='!active')
                v-avatar.white--text.text-uppercase(left='' color='blue' v-text='item.slice(0, 1)')
                |                 {{ item }}
        v-date-picker.mt-2(color='primary' full-width='' v-model='graphDate')
      v-col(lg='6' cols='12')
        v-row
          v-col.pa-2.mb-0(cols='12')
            v-card
              v-toolbar(color='primary' dark dense flat)
                span Expense Category
              v-container
                v-autocomplete(
                  label='Expense Category'
                  v-model='expenseCategory'
                  :items='expenseCategoryList'
                  item-value='id'
                  item-text='description'
                  :clearable='Boolean(expenseCategory)'
                )
          v-col.pa-2.mb-0(cols='6' lg='6')
            base-material-stats-card.text-capitalize(color='primary' icon='mdi-currency-usd' :title="`${dateIntervalItems[dateIntvSelected].replace('ly', '')} Sales`" :value='rangeSales.phpFormat()')
          //- v-col.pa-2.mb-0(cols='6' lg='6')
            base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntvSelected].replace('ly', '')} Purchases`" :value='rangeRecieved.phpFormat()')
          v-col.pa-2.mb-0(cols='6' lg='6')
            base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntvSelected].replace('ly', '')} Expenses`" :value='rangeExpenses.phpFormat()')
          v-col.pa-2.mb-0(cols='6' lg='6')
            base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntvSelected].replace('ly', '')} Collectibles`" :value='collectibles.phpFormat()')
          v-col.pa-2.mb-0(cols='6' lg='6')
            base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntvSelected].replace('ly', '')} Loan Lent`" :value='rangeLoanLent.phpFormat()')
          v-col.pa-2.mb-0(cols='6' lg='6')
            base-material-stats-card.text-capitalize(color='primary' icon='mdi-account-details' :title="`${dateIntervalItems[dateIntvSelected].replace('ly', '')} Loan Paid`" :value='rangeLoanPaid.phpFormat()')
</template>
<script>
  import { apiVars, intervalGetters } from '@/extra-functions/api-helper.extra'
  import expenseRepository from '@/repositories/expense.repository'
  import cxLoanInvRepository from '@/repositories/consumer-loan-inventory.repository'
  import cxLoanTxnRepository from '@/repositories/consumer-loan-transaction.repository'
  import rcvInvRepository from '@/repositories/recieved-inventory.repository'
  import lostInvRepository from '@/repositories/lost-inventory.repository'
  import saleInvRepository from '@/repositories/sale-inventory.repository'
  import VueRequestHandler from '@/classes/VueRequestHandler.class'
  import requestVars from '@/extra-functions/request-vars.extra'
  import { errorHandler } from '@/extra-functions/store.extra'
  import { moneyMixin } from '@/views/dashboard/mixins/helper.mixins'
  import expenseCategoryRepository from '@/repositories/expense-category.repository'
  import { mapState } from 'vuex'

  const [expenseStoreIntervalGetVars, expenseStoreIntervalGetVarNames] = requestVars({ identifier: 'expense-store-interval' })
  const [expenseCategoryGetVars, expenseCategoryGetVarNames] = requestVars({ identifier: 'expense-category' })

  const expenseStoreIntervalGetHandler = new VueRequestHandler(null, expenseStoreIntervalGetVarNames)
  const expenseCategoryGetHandler = new VueRequestHandler(null, expenseCategoryGetVarNames)

  const getCurrentDate = () => {
    const date = new Date()
    const year = date.getFullYear()
    const month = (`${date.getMonth() + 1}`).padStart(2, '0')
    const day = (`${date.getDate()}`).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const internalGetterCallBack = (c) => {
    return function (date) {
      this[c.loadingName] = true
      c.delay(() => {
        c.repository[`${c.suffix.toLowerCase()}All`]({ date })
          .then(({ data }) => { this[c.listName] = data })
          .catch(e => { this[c.errorName] = errorHandler(e) })
          .then(() => { this[c.loadingName] = false })
      })
    }
  }

  const dateIntvVariables = () => {
    const identifier = 'dateIntv'
    return {
      [`${identifier}Selected`]: 1,
      [`${identifier}Items`]: ['weekly', 'monthly', 'yearly'],
    }
  }

  const calendarVariables = () => {
    const graphDate = getCurrentDate()
    return {
      graphDate,
    }
  }
  const snakeToCamel = (str) => str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))

  const storeVars = (storeNum) => {
    const varNames = [
      'sale-inv',
      'cx-loan-txn',
      'cx-loan-inv',
      'lost-inv',
      'expense-store-interval',
      // 'RcvInv',
    ]
    const obj = {}

    for (let i = 0; i < storeNum; i++) {
      Object.assign(obj, {
        [`store${i + 1}`]: function () {
          const arr = varNames.map(e => {
            const row = this[snakeToCamel(`${e}-list`)].find(e => e.store_id === this.stores[i].id)
            return row === undefined ? 0 : row.tamount
          })
          return arr
        },
      })
    }
    return obj
  }

  export default {
    name: 'IndexStore',
    components: {
      storeCompChart: () => import('@/views/dashboard/components/store-summaries/sub-components/StoreComparisonChart'),
    },
    data () {
      return {
        ...apiVars('cxLoanInv'),
        ...apiVars('cxLoanTxn'),
        ...apiVars('lostInv'),
        ...apiVars('saleInv'),
        // ...apiVars('rcvInv'),
        ...expenseStoreIntervalGetVars,
        ...expenseCategoryGetVars,
        ...dateIntvVariables(),
        ...calendarVariables(),
        dateIntervalItems: ['weekly', 'monthly', 'yearly'],
        expenseCategory: {},
      }
    },
    created () {
      this.getData()
      this.getExpenseCategories()
    },
    computed: {
      ...mapState({
        stores: state => state.branchLocation.list,
      }),
      rangeSales () {
        const sales = this.saleInvList.reduce((t, c) => t + c.tamount, 0)
        const paidLoans = this.cxLoanTxnList.reduce((t, c) => t + c.tamount, 0)
        return sales + paidLoans
      },
      rangeExpenses () {
        return this.expenseStoreIntervalList.reduce((t, c) => t + c.tamount, 0)
      },
      rangeRecieved () {
        // return this.rcvInvList.reduce((t, c) => t + c.tamount, 0)
        return 0
      },
      rangeLoanPaid () {
        return this.cxLoanTxnList.reduce((t, c) => t + c.tamount, 0)
      },
      rangePurchases () {
        return this.purchases.reduce((t, c) => t + c.tamount, 0)
      },
      rangeLoanLent () {
        return this.cxLoanInvList.reduce((t, c) => t + c.tamount, 0)
      },
      collectibles () {
        return this.rangeLoanLent - this.rangeLoanPaid
      },
      ...storeVars(7),
      graphData () {
        return this.stores.map((e, i) => {
          return this[`store${i + 1}`]
        })
      },
      loadingServerSideData () {
        return this.cxLoanTxnLoading ||
          this.saleInvLoading ||
          this.lostInvLoading ||
          // this.rcvInvLoading ||
          this.cxLoanInvLoading
      },
    },
    watch: {
      graphDate () {
        this.getData()
      },
      dateIntvSelected () {
        this.getData()
      },
      expenseCategory () {
        this.getExpenseStoreIntervals()
      },
    },
    methods: {
      ...intervalGetters('cx-loan-inv', cxLoanInvRepository, internalGetterCallBack),
      ...intervalGetters('cx-loan-txn', cxLoanTxnRepository, internalGetterCallBack),
      ...intervalGetters('lost-inv', lostInvRepository, internalGetterCallBack),
      ...intervalGetters('sale-inv', saleInvRepository, internalGetterCallBack),
      ...intervalGetters('rcv-inv', rcvInvRepository, internalGetterCallBack),
      getData () {
        const funcs = [
          'CxLoanInv',
          'CxLoanTxn',
          'LostInv',
          'SaleInv',
          'RcvInv',
        ]
        const intervals = ['Weekly', 'Monthly', 'Yearly']
        funcs.forEach(e => { this[`fetch${e}${intervals[this.dateIntvSelected]}`](this.graphDate) })
        this.getExpenseStoreIntervals()
      },
      getExpenseStoreIntervals () {
        const handler = expenseStoreIntervalGetHandler
        const repository = expenseRepository.storeIntervals
        const params = this.expenseStoreIntervalParams()
        handler.setVue(this)
        handler.execute(repository, [params])
      },
      expenseStoreIntervalParams () {
        const intervals = ['weekly', 'monthly', 'yearly']
        return {
          date: this.graphDate,
          interval: intervals[this.dateIntvSelected],
          sum: true,
          category: this.expenseCategory,
        }
      },
      getExpenseCategories () {
        const handler = expenseCategoryGetHandler
        const repository = expenseCategoryRepository.index
        handler.setVue(this)
        handler.execute(repository)
      },
    },
    mixins: [
      moneyMixin,
    ],
  }
</script>
